import { List, Map, Record } from "immutable";

import { CrudBuilderState } from "seneca-common/utils/apiStates";

import { CourseEnrollments } from "./CourseEnrollments";
import courseEnrollmentsMetaInitialState from "./CourseEnrollmentsMeta";

export type CourseEnrollmentsStateSliceType = {
  enrollments: CourseEnrollments;
  meta: CrudBuilderState | Map<any, any>;
};

export type OptionalCourseEnrollmentsStateSliceType =
  Partial<CourseEnrollmentsStateSliceType>;

const defaultCourseEnrollmentsStateSlice: CourseEnrollmentsStateSliceType = {
  enrollments: List(),
  meta: courseEnrollmentsMetaInitialState
};

export default class CourseEnrollmentsStateSlice extends Record(
  defaultCourseEnrollmentsStateSlice
) {}
